import { REASSURANCE_QUOTE, READING_PATHS } from "../../data/reportContent";

const jumpTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const OrientationPanel = () => (
  <div className="orientation-panel no-print" data-testid="orientation-panel">
    <blockquote className="orientation-quote" data-testid="orientation-reassurance-quote">
      <p>{REASSURANCE_QUOTE}</p>
    </blockquote>
    <div className="orientation-kicker">Before you begin: how to read this report</div>
    <div className="orientation-paths">
      {READING_PATHS.map((p) => (
        <button
          key={p.audience}
          className="orientation-path"
          onClick={() => jumpTo(p.targetId)}
          data-testid={`orientation-path-${p.targetId}`}
        >
          <span className="orientation-path-audience">{p.audience} →</span>
          <span className="orientation-path-guidance">{p.guidance}</span>
        </button>
      ))}
    </div>
  </div>
);
